module.exports = __webpack_public_path__ + "assets/img/sp-global.f88e9888.png";